import { render, staticRenderFns } from "./article-highlight-push.vue?vue&type=template&id=038d02cb"
import script from "./article-highlight-push.vue?vue&type=script&lang=js"
export * from "./article-highlight-push.vue?vue&type=script&lang=js"
import style0 from "./article-highlight-push.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports